import toast from "components/Toast/Toast"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import { Col, Form, FormFeedback, Input, Label, Row, Spinner } from "reactstrap"
import { findRoleById, getPermissions, updateRole } from "services/users/calls"
import * as Yup from "yup"

const UpdateProfile = props => {
  let { id } = useParams()
  let history = useHistory()
  const [isLoading, handleLoading] = useState(true)
  const [roles, setRole] = useState([])
  const [initValues, setInitValues] = useState({})
  const [permissions, setPermissions] = useState([])
  const [error, setError] = useState([])

  useEffect(() => {
    handleLoading(true)
    fetchPermissions()
  }, [])

  const fetchPermissions = async () => {
    try {
      const { payload } = await getPermissions()
      const { permissions } = payload
      setPermissions(permissions)
      const { payload: roleById } = await findRoleById(id)
      setRole(roleById)
      setInitValues({
        name: roleById.name,
        permissions: roleById.permissions.map(e => {
          return String(e.id)
        }),
      })
    } catch (error) {
      console.warn(error)
      setError(error)
    } finally {
      handleLoading(false)
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initValues,
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(3, "Nome muito pequeno")
        .max(255, "Máximo de 255 caracteres permitido para Nome.")
        .required("Campo nome é obrigatório."),
    }),
    onSubmit: async (values, { resetForm }) => {
      const { name, permissions } = values
      if (isLoading) return
      handleLoading(true)
      try {
        await onCreateOrUpdate(
          name,
          permissions.map(e => Number(e))
        )
        toast("success", "Perfil atualizado com succeso.")
        resetForm()
      } catch (error) {
        toast("error", error?.message, "Erro")
      } finally {
        handleLoading(false)
      }
    },
  })

  const onCreateOrUpdate = async (name, permissions) => {
    try {
      const { payload } = await updateRole(id, name, permissions)
      toast("success", "Perfil atualizado com succeso.")
      props.setReRenderList(!props.reRenderList)
      props.setNav(0)
      history.push("/configuracoes/acessos/perfis")
    } catch (error) {
      throw error
    }
  }

  return (
    <React.Fragment>
      <Row>
        <p>Atualização de Cadastro</p>
      </Row>
      <Row>
        <Form
          className="form-horizontal"
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Row>
              <Col>
                <Label className="form-label">Dados do Perfil</Label>
                <Input
                  name="name"
                  className="form-control"
                  placeholder="Nome do Perfil"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                  autoComplete="off"
                />
                {validation.touched.name && validation.errors.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </div>
          {permissions.length > 0 && (
            <div className="mb-3">
              <Label className="form-check-label">Permissões</Label>
              <br />
              {permissions.map(permission => {
                return (
                  <div
                    className="form-check mb-1"
                    key={`permission-${permission.id}`}
                  >
                    <Input
                      className="mr-2"
                      id={`permission-${permission.id}`}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={permission.id}
                      checked={
                        validation.values.permissions?.includes(
                          String(permission.id)
                        )
                          ? true
                          : false
                      }
                      name="permissions"
                      type="checkbox"
                    />
                    <Label
                      htmlFor={`permission-${permission.id}`}
                      className="form-check-label"
                    >
                      {permission.name}
                    </Label>
                  </div>
                )
              })}
            </div>
          )}
          {isLoading && (
            <div className="mt-3" style={{ textAlign: "center" }}>
              <Spinner className="ms-2" color="primary" />
            </div>
          )}
          {!isLoading && (
            <div className="mt-3 d-grid">
              <button className="btn btn-primary btn-block" type="submit">
                Cadastrar
              </button>
            </div>
          )}
        </Form>
      </Row>
    </React.Fragment>
  )
}

UpdateProfile.propTypes = {
  t: PropTypes.any,
  reRenderList: PropTypes.bool,
  setReRenderList: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(UpdateProfile)
